import { CommonModule } from '@angular/common';
import { Component, Input,ANIMATION_MODULE_TYPE } from '@angular/core';
import { ActivatedRoute, RouterModule, RouterOutlet } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { GeneralEmitterService } from '../../services/general-emitter.service';

@Component({
  selector: 'app-product-card',
  standalone: true,
  imports: [CommonModule, RouterModule, RouterOutlet,
    ToastModule, ButtonModule, RippleModule
  ],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss',
  providers: [],
})
export class ProductCardComponent {
  @Input() product: any  = {};
  showAlert = false;
  messages: any = [];
  
  constructor(
    // private messageService: AlertsService
    private emitterData: GeneralEmitterService
  ) {
  }

  ngOnInit() {
    

  }
  addMessages() {
    this.messages = [
        { severity: 'info', summary: 'Dynamic Info Message' },
        { severity: 'success', summary: 'Dynamic Success Message' },
        { severity: 'warn', summary: 'Dynamic Warning Message' }
    ];
}

  addCart() {
    let cart: any = JSON.parse(localStorage.getItem('productCart') ?? '[]');
    cart.push(this.product)
    console.log('cart :', cart);
    localStorage.setItem('productCart', JSON.stringify(cart));
    this.emitterData.chartData.emit(true);

  }
}
